import * as api from '../../services/allot'

export const FETCH_ALLOTS= 'FETCH_ALLOTS';




export const fetchAllots = (params, pagination, sort, extra) => {

    return {
        type: FETCH_ALLOTS,
        payload: {
            promise: api.findAllots(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    };
};



// WEBPACK FOOTER //
// ./src/redux/actions/allot.js